'use client';

import { CustomError } from '@core/utils';
import { useShallow } from 'zustand/react/shallow';

import { useCustomRouter } from '@/hooks/useCustomRouter';
import { DEFAULT_LOCATION } from '@/hooks/useLocation';
import { useAuthStore } from '@/stores/AuthStore';

import { FeedList } from './FeedList';
import { FeedRegionBar } from './FeedRegionBar';

interface FeedSectionProps {
  codeRegion?: string;
  codeSubRegion?: string;
}

export const FeedSection = ({
  codeRegion,
  codeSubRegion,
}: FeedSectionProps) => {
  const [selectedCodeRegion, selectedCodeSubRegion] = useAuthStore(
    useShallow(({ region, myInfo }) => [
      codeRegion ||
        region?.at(0)?.codeRegion ||
        myInfo?.codeRegion ||
        DEFAULT_LOCATION.codeRegion,
      codeSubRegion ||
        region?.at(0)?.codeSubRegion ||
        myInfo?.codeSubRegion ||
        DEFAULT_LOCATION.codeSubRegion,
    ]),
  );

  const router = useCustomRouter();

  return (
    <section className="flex flex-col bg-Gray-white xl:bg-transparent">
      <FeedRegionBar
        value={{
          mainRegionCode: selectedCodeRegion,
          subRegionCode: selectedCodeSubRegion,
        }}
        onChange={({ mainRegion, subRegion }) => {
          if (!mainRegion.code || !subRegion.code)
            throw new CustomError({
              return_message: '지역 데이터가 올바르지 않습니다.',
            });

          if (subRegion.code === selectedCodeSubRegion) return;

          const params = new URLSearchParams(window.location.search);

          params.set('codeRegion', mainRegion.code);
          params.set('codeSubRegion', subRegion.code);

          router.replace(`?${params.toString()}`);
        }}
      />
      <FeedList
        codeRegion={selectedCodeRegion}
        codeSubRegion={selectedCodeSubRegion}
      />
    </section>
  );
};
